export var WishlistErrorTypes;
(function (WishlistErrorTypes) {
    WishlistErrorTypes["COUNT_EXCEEDED"] = "Maximum Item Count exceeded";
})(WishlistErrorTypes || (WishlistErrorTypes = {}));
//# sourceMappingURL=wishlistErrorTypes.js.map